export const camelToSnakeCase = (string) => string
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();
export const snakeToCamelCase = (string) => {
    return string.replace(/(^__|(?<!^)_)(.)/g, (match, leadingOrInner, letter) => leadingOrInner === "__" ? match : letter.toUpperCase());
};
//# sourceMappingURL=string.js.map